mutation loginFromMiddle($token: String!) {
  getAccess(key: $token) {
    token
    data {
      merchantId
      username
      integration
      status
      groups
    }
  }
}

query ListFontsQuery {
  listFonts
}

query GetStylesQuery($merchantId: ID!) {
  getStyles(merchantId: $merchantId)
}

mutation SaveStylesMutation(
  $merchantId: ID!
  $data: String!
  $mainLogo: String!
  $shortLogo: String!
) {
  saveStyles(merchantId: $merchantId, data: $data, mainLogo: $mainLogo, shortLogo: $shortLogo)
}

query SearchProductsQuery($partial: String!) {
  searchProducts(partial: $partial) {
    brand
    brandSlug
    name
    id
    skus {
      name
      id
      productId
      sku
      vto {
        color
        coverage
        effectUrl
        finish
        id
        region
        season
      }
    }
    cover
    type
    category {
      id
      name
    }
  }
}

query MerchantsQuery {
  merchants {
    id
    name
    email
    domain
  }
}

query MerchantByIdQuery($merchantId: ID!) {
  merchantById(id: $merchantId) {
    id
    name
    email
    domain
    planId
    brandsIds
    description
    cognitoSub
    token
  }
}

query resolveMerchant($id: ID!) {
  resolveMerchant(id: $id)
}

query resolveMerchantByUName($cname: String!) {
  resolveMerchantByUName(cname: $cname)
}

query BrandByIdQuery($id: ID!, $sub: String) {
  brand(id: $id, sub: $sub) {
    id
    name
    slug
  }
}

mutation SaveBrandMutation($brandId: ID, $slug: String!, $name: String!, $sub: String) {
  saveBrand(brand: { id: $brandId, slug: $slug, name: $name }, sub: $sub)
}

query BrandsQuery {
  brands(adminMode: true) {
    id
    name
    slug
  }
}

query Brandslist($merch: String) {
  brandsV2(merchant: $merch) {
    id
    name
    slug
  }
}

mutation ToggleLookVisibilityMutation($lookId: ID!, $visible: Boolean!) {
  toggleLookVisibility(lookId: $lookId, visible: $visible)
}

mutation ToggleProductVisibilityMutation($productId: ID!, $visible: Boolean!) {
  toggleProductVisibility(productId: $productId, visible: $visible)
}

mutation DeleteLookMutation($lookId: String!) {
  deleteLook(lookId: $lookId)
}

mutation DeleteProductMutation($productId: ID!) {
  deleteProduct(productId: $productId)
}

query AllLooksQuery {
  allLooks {
    brand
    name
    visible
    products {
      products {
        skus {
          vto {
            color
            coverage
            effectUrl
            finish
            id
            region
            season
          }
          name
          id
          productId
          sku
        }
        brand
        brandSlug
        category {
          name
          id
        }
        cover
        id
        name
        price {
          amount
          currency
        }
        type
      }
      selectedSkus {
        vto {
          color
          coverage
          effectUrl
          finish
          id
          region
          season
        }
        id
        productId
        sku
      }
    }
    id
    brandSlug
    cover
    price {
      amount
      currency
    }
  }
}

query ProductQuery($productId: ID!) {
  product(id: $productId) {
    brand
    brandSlug
    name
    id
    skus {
      name
      id
      productId
      sku
      url
      upc
      vto {
        color
        coverage
        effectUrl
        finish
        id
        region
        season
      }
    }
    cover
    type
    category {
      id
      name
    }
  }
}

query ProductQueryV2($productId: ID!) {
  productV2(id: $productId) {
    brand
    brandSlug
    name
    id
    skus {
      name
      id
      productId
      sku
      url
      upc
      vto {
        color
        coverage
        effectUrl
        finish
        id
        region
        season
      }
    }
    merchant
    cover
    type
    category {
      id
      name
    }
  }
}

query LookQuery($lookId: ID!) {
  look(id: $lookId) {
    name
    products {
      products {
        brand
        brandSlug
        category {
          id
          name
        }
        cover
        id
        name
        price {
          amount
          currency
        }
        skus {
          id
          name
          productId
          sku
          vto {
            color
            coverage
            effectUrl
            finish
            id
            region
            season
          }
        }
        type
      }
      selectedSkus {
        id
        name
        productId
        sku
        vto {
          color
          coverage
          effectUrl
          id
          finish
          region
          season
        }
      }
    }
    brand
    brandSlug
    cover
    id
    price {
      amount
      currency
    }
  }
}

query MerchStatus($id: ID!) {
  merchantStatus(id: $id)
}

query ProductsQuery($page: Int, $partial: String!, $brand: String, $adminMode: Boolean) {
  products(offset: $page, adminMode: $adminMode, partial: $partial, brand: $brand) {
    items {
      brand
      brandSlug
      name
      id
      skus {
        name
        id
        productId
        sku
        vto {
          color
          coverage
          effectUrl
          finish
          id
          region
          season
        }
      }
      cover
      type
      visible
    }
    pageInfo {
      hasNext
      pageQty
    }
  }
}

query ProductsQueryV2($page: Int, $partial: String!, $category: String!, $merchant: String, $limit: Int) {
  productsV2(offset: $page, category: $category, partial: $partial, merchant: $merchant, limit: $limit) {
    items {
      brand
      brandSlug
      name
      id
      externalId
      state
      skus {
        name
        id
        productId
        sku
        vto {
          color
          coverage
          effectUrl
          finish
          id
          region
          season
        }
      }
      cover
      type
      visible
    }
    pageInfo {
      hasNext
      pageQty
    }
  }
}

query ProductCategoriesQuery {
  categories {
    id
    name
  }
}

query ProductTypesQuery {
  types {
    id
    name
  }
}

mutation ListUsersMutation {
  listUsers {
    sub
    username
    groups
  }
}

mutation DeleteUserMutation($username: String!) {
  deleteUser(username: $username)
}

mutation RegisterUserMutation($username: String!, $password: String!, $group: String!) {
  registerUser(username: $username, password: $password, group: $group)
}

mutation UpdateUserMutation($username: String!, $password: String!) {
  updateUser(username: $username, password: $password)
}

mutation RefreshTokenMutation($refreshToken: String!) {
  refreshToken(token: $refreshToken)
}

query AuthorizeCDNQuery {
  authorizeCDN
}

mutation SaveMerchantMutation(
  $merchantId: ID!
  $name: String!
  $email: String!
  $domain: String!
  $planId: Int!
  $cognitoSub: String!
  $description: String!
  $brandsIds: [ID!]
  $token: String!
) {
  saveMerchant(
    merchant: {
      id: $merchantId
      name: $name
      email: $email
      domain: $domain
      planId: $planId
      cognitoSub: $cognitoSub
      description: $description
      brandsIds: $brandsIds
      token: $token
    }
  )
}

input ProductAndSku {
  product: ID!
  sku: ID!
}

mutation SaveLookMutation(
  $lookId: ID
  $cover: String!
  $name: String!
  $products: [ProductAndSku!]
) {
  saveLook(look: { id: $lookId, cover: $cover, name: $name, products: $products })
}

input VTOInput {
  region: String!
  color: String!
  finish: String!
  coverage: String!
}

input ProductSkuInput {
  id: ID
  productId: ID
  name: String!
  externalId: String
  sku: String!
  upc: String!
  vto: VTOInput!
  url: String
}

input PriceInput {
  amount: Float!
  currency: String!
}

mutation SaveProductMutation(
  $id: ID
  $name: String!
  $brandId: Int!
  $categoryId: Int!
  $typeId: Int!
  $cover: String!
  $price: PriceInput!
  $skus: [ProductSkuInput!]!
) {
  saveProduct(
    product: {
      id: $id
      name: $name
      brandId: $brandId
      categoryId: $categoryId
      typeId: $typeId
      cover: $cover
      price: $price
      skus: $skus
    }
  )
}

mutation SaveProductMutationV2(
  $id: ID
  $name: String!
  $brandId: Int
  $brand: String
  $merchant: String!
  $categoryId: Int!
  $typeId: Int!
  $cover: String!
  $price: PriceInput!
  $skus: [ProductSkuInput!]!
  $externalId: String
) {
  saveProductV2(
    product: {
      externalId: $externalId
      id: $id
      name: $name
      brandId: $brandId
      brand: $brand
      categoryId: $categoryId
      typeId: $typeId
      cover: $cover
      price: $price
      skus: $skus
      merchant: $merchant
    }
  )
}

query GetTranslates {
  loadLangConfigs
}

mutation SaveTranslates($data: String!) {
  saveLangConfigs(data: $data)
}

query GetProductsV2(
  $page: Int
  $partial: String
  $category: String
  $adminMode: Boolean
  $merchant: String
) {
  productsV2(
    offset: $page
    partial: $partial
    adminMode: $adminMode
    category: $category
    merchant: $merchant
  ) {
    items {
      brand
      brandSlug
      name
      id
      skus {
        name
        id
        productId
        sku
        upc
        url
        vto {
          color
          coverage
          effectUrl
          finish
          id
          region
          season
        }
      }
      cover
      type
      visible
    }
    pageInfo {
      hasNext
      pageQty
    }
  }
}

mutation BulkUpload($file: String!, $headers: String) {
  uploadBulkNative(file: $file, headers: $headers)
}

query GetAnalytics($merchantID: ID!, $days: String, $dateStart: String, $dateEnd: String) {
  analytics(days: $days, dateStart: $dateStart, dateEnd: $dateEnd, merchantId: $merchantID)
}

query GetProductTranslations($productId: ID!, $skuIds: [ID!]!) {
  alternateName: getI8N(productId: $productId) {
    code
    name
  }
  alternateSKUsName: skusI8N(skuIds: $skuIds) {
    skuId
    skuI8N {
      code
      name
    }
  }
}

mutation SaveProductI8NFromAdmin($Id: ID, $merchantID: ID, $data: String) {
  saveI8N(merchantId: $merchantID, productId: $Id, data: $data)
}

mutation SaveSKUI8NFromAdmin($Id: ID, $merchantID: ID, $data: String) {
  saveI8N(merchantId: $merchantID, skuId: $Id, data: $data)
}
